import * as Actions from '../../actions';

const initialState = { data: null };

const listSilosReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_SILO_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listSilosReducer;
